export default __webpack_public_path__ + "static/media/tutorial_4.b728c7e7.svg";